import { useMemo } from 'react';
export var useCurrentSelectionEntityType = function useCurrentSelectionEntityType(editorState) {
  return useMemo(function () {
    var entityKey = editorState.getCurrentContent().getBlockMap().get(editorState.getSelection().getAnchorKey()).getEntityAt(editorState.getSelection().getAnchorOffset());

    if (null === entityKey) {
      return null;
    }

    return editorState.getCurrentContent().getEntity(entityKey).getType();
  }, [editorState]);
};